export const DATA_FIRESTORE_V01_V01_SCORE_CARDS = {
  NAME: 'v01_score_cards',

  FIELDS: {
    VERSION: {
      KEY: 'v',
      DEFAULT: 1,
    },

    OWNER: {
      KEY: 'owner',
      DEFAULT: null,
    },

    TYPE: {
      KEY: 'type',
      DEFAULT: null,
    },

    IS_PUBLIC: {
      KEY: 'isPublic',
      DEFAULT: null,
    },
  },
}
